import Phone from '../phone';

function applyMask(input) {
  input.value = Phone.applyMask(input.value);
}

export default function maskPhone(input) {
  applyMask(input);

  input.addEventListener('input', function (e) {
    applyMask(input);
  })
}
